import { availableRandomActions, is_room_activated } from './StationUtilities';

const RESEARCH_ACTION_ROOMS = [1, 2, 49]
const LODGING_ACTION_ROOMS = [3, 4, 50]
const ROBOT_ACTION_ROOMS = [5, 6, 51]
const RENOVATION_ACTION_ROOMS = [7, 8, 52]
const ADVERTISEMENT_ACTION_ROOMS = [9, 10, 53]
const GHOST_ACTION_ROOMS = [11, 12, 54]
const ACTION_ROOM_TYPES = [
    null,
    RESEARCH_ACTION_ROOMS,
    LODGING_ACTION_ROOMS,
    ROBOT_ACTION_ROOMS,
    RENOVATION_ACTION_ROOMS,
    ADVERTISEMENT_ACTION_ROOMS,
    GHOST_ACTION_ROOMS,
]
const UPGRADED_ACTION_ROOMS = [1, 3, 5, 7, 9, 11]
// Edge positions follow the [next-direction-focus, prev-direction-focus]
// convention. ActionChooser renders 12 slides in ascending action_id
// order (slides 0-1 Research, 2-3 Lodging, ..., 10-11 Ghost). The
// visible center pair at realIndex K is (slideAction(K+2),
// slideAction(K+3)) — always lower-action-id first. For the data to
// match what the player sees, every edge must read [lower-id,
// higher-id]. Position 9 (Staff-Lodging edge) was the lone violator
// at [3, 2]; corrected to [2, 3] to match the pattern and the visual.
const ACTION_HEX_ACTIONS = [
    [1, 1], [6, 1],
    [6, 6], [5, 6],
    [5, 5], [4, 5],
    [4, 4], [3, 4],
    [3, 3], [2, 3],
    [2, 2], [1, 2]
];
const ACTION_TEXTURES = [null, 71, 72, 73, 74, 75, 76, 83];
const FACTION_ACTION_TEXTURES = [null, 59, 60, 61, 62, 63, 64];
const RANDOM_ACTION_SELECTOR = 83;

// Manual 7.1 Action Windows. Mirrors hsh_python/engine/round_choices/
// action_grid.py:_current_window.
export const WINDOW_A = 'A';
export const WINDOW_B = 'B';
export const WINDOW_C = 'C';
export const WINDOW_MAIN_SET = 'MAIN_SET';



// really not sure what this is for actually other than Fossa's room activator.
export function matching_action_room_indexes(station, action_id) {
    let matching_action_room_types = ACTION_ROOM_TYPES[action_id];
    let indexes = [];
    station.forEach((room_id, stationIndex) => {
        if (room_id) {
            if (matching_action_room_types.includes(room_id)) {
                indexes.push(stationIndex);
            }
        }
    })
    return indexes
}

export function matching_action_room_points(station, robot_assignments, action_id) {
    let action_points = 0;
    let action_room_types = ACTION_ROOM_TYPES[action_id];
    station.forEach((room_id, stationIndex) => {
        if (action_room_types.includes(room_id)) {
            if (is_room_activated(station, stationIndex, robot_assignments)) {
                action_points += 1;
                if (UPGRADED_ACTION_ROOMS.includes(room_id)) {
                    action_points += 1;
                }
            }
        }
    })
    return action_points;
}

export function get_action_points(station, robot_assignments) {
    const actions = [1, 2, 3, 4, 5, 6];
    return actions.map((action_id) => {
        return 1 + matching_action_room_points(station, robot_assignments, action_id);
    });
}


function default_available_actions() {
    return [ [ null, null, null, null ], [ null, null, null, null ] ];
}

export function available_action_hex_actions(
        station, robot_assignments, action_hex_position,
        locked_action_stacks, available_actions) {
    let action_type_points = get_action_points(station, robot_assignments);
    let positionActions = ACTION_HEX_ACTIONS[action_hex_position];
    let currentAvailableActions = default_available_actions();
    default_available_actions().map((stack, stackIndex) => {
        let stack_is_locked = locked_action_stacks[stackIndex];
        if (stack_is_locked) {
            currentAvailableActions[stackIndex] = available_actions[stackIndex];
        } else {
            let action_id = positionActions[stackIndex];
            let stackPoints = action_type_points[action_id - 1];
            currentAvailableActions[stackIndex] = new Array(stackPoints).fill(action_id);
        }
    })
    return currentAvailableActions;
}

export function getActionGrid(
        available_actions, action_tokens, available_random_actions) {
    let action_grid = [];
    available_actions.forEach((stack) => {
        stack.forEach((action_id) => action_grid.push(ACTION_TEXTURES[action_id]));
    });
    action_tokens.forEach((action_id) => action_grid.push(FACTION_ACTION_TEXTURES[action_id]));
    available_random_actions.forEach(() => action_grid.push(RANDOM_ACTION_SELECTOR));
    return action_grid.filter(action => ![null, undefined].includes(action));
}


export function currentActionGrid(gamePlayerData) {
    let availableActions = available_action_hex_actions(
        gamePlayerData.station, gamePlayerData.robot_assignments,
        gamePlayerData.action_hex_position,
        gamePlayerData.locked_action_stacks,
        gamePlayerData.available_actions);
    return getActionGrid(
        availableActions,
        gamePlayerData.action_tokens,
        availableRandomActions(gamePlayerData));
}


function stackHasRemaining(stack) {
    return stack.some((actionId) => actionId !== null && actionId !== undefined);
}


export function currentWindow(lockedActionStacks, availableActions) {
    let inProgress = lockedActionStacks.map((locked, stackIndex) =>
        locked && stackHasRemaining(availableActions[stackIndex]));
    if (inProgress.some((flag) => flag)) return WINDOW_MAIN_SET;
    if (lockedActionStacks.every((locked) => !locked)) return WINDOW_A;
    if (lockedActionStacks.every((locked) => locked)) return WINDOW_C;
    return WINDOW_B;
}


export function bonusActionGridIndexes(
        availableActions, actionTokens, randomActionsCount) {
    let mainCount = 0;
    availableActions.forEach((stack) => {
        stack.forEach((actionId) => {
            if (actionId !== null && actionId !== undefined) mainCount += 1;
        });
    });
    let bonusCount = actionTokens.length + randomActionsCount;
    let indexes = [];
    for (let i = 0; i < bonusCount; i += 1) {
        indexes.push(mainCount + i);
    }
    return indexes;
}


export function disabledActionGridIndexes(gamePlayerData) {
    let window = currentWindow(
        gamePlayerData.locked_action_stacks,
        gamePlayerData.available_actions);
    if (window !== WINDOW_MAIN_SET) return [];

    // Re-derive the rendered stacks the same way currentActionGrid
    // does. For a locked stack this is gamePlayerData.available_actions[i];
    // for an unlocked stack it's the hex-position-derived array.
    // Using the same source keeps cursor math aligned with what the
    // player actually sees, even if action_hex_position has been
    // rotated since the first stack was locked.
    let renderedStacks = available_action_hex_actions(
        gamePlayerData.station,
        gamePlayerData.robot_assignments,
        gamePlayerData.action_hex_position,
        gamePlayerData.locked_action_stacks,
        gamePlayerData.available_actions);

    let indexes = [];
    let cursor = 0;
    renderedStacks.forEach((stack, stackIndex) => {
        let tiles = stack.filter(
            (a) => a !== null && a !== undefined);
        let isActive = gamePlayerData.locked_action_stacks[stackIndex]
            && tiles.length > 0;
        if (!isActive) {
            for (let i = 0; i < tiles.length; i += 1) {
                indexes.push(cursor + i);
            }
        }
        cursor += tiles.length;
    });

    // Bonus tail (faction tokens + random actions) — already greyed
    // during MAIN_SET per Manual §7.1.
    let bonus = bonusActionGridIndexes(
        renderedStacks,
        gamePlayerData.action_tokens,
        availableRandomActions(gamePlayerData).length);
    return indexes.concat(bonus);
}


// Texture-class predicates. Used by ActionSelector / ActionPicker
// onClick to discriminate Main Hex actions (which lock the hex)
// from Faction tokens / Random selectors (which do NOT — Manual
// ruling per CC_RANDOM_FACTION_NO_HEX_LOCK).
export function isMainHexActionTexture(texture) {
    // Slice off the leading null and the trailing Random selector
    // (texture 83 at index 7). Main Hex action textures are 71-76.
    return ACTION_TEXTURES.slice(1, 7).includes(texture);
}

export function factionActionIdForTexture(texture) {
    // FACTION_ACTION_TEXTURES[i] = texture for faction i. Returns
    // the faction action_id (1-6) or null if not a faction texture.
    let index = FACTION_ACTION_TEXTURES.indexOf(texture);
    return index > 0 ? index : null;
}

export function isRandomActionTexture(texture) {
    return texture === RANDOM_ACTION_SELECTOR;
}
